import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const $win = $(window);
const $doc = $(document);

$doc
  .on('mouseenter', '.nav > ul > .menu__item--has-dropdown', () => {
    $('.wrapper').addClass('js-overlay');
  })
  .on('mouseleave', '.nav  > ul > .menu__item--has-dropdown', () => {
    $('.wrapper').removeClass('js-overlay');
  })
  .on('click', '.nav-mobile .nav__menu > ul > .menu__item--has-dropdown > a', function(e) {
    const $this = $(this);

    if (!$this.hasClass('clicked')) {
      e.preventDefault();

      $this.addClass('clicked');

      $this.parent().siblings().children('.menu__dropdown').slideUp();
      $this.next().slideDown();
    }
  })
  .on('click', '.js-nav-trigger', function(e){
    e.preventDefault();

    $('.nav-mobile').toggleClass('is-active');

    if ($('.nav-mobile').hasClass('is-active')) {
      disableBodyScroll($('.nav-mobile')[0]);
    } else {
      enableBodyScroll($('.nav-mobile')[0]);
    }
  })